interface FullStoryUserVars {
  displayName: string;
  email: string;
  roles: string[];
  [key: string]: unknown;
}

export function identifyUser(uid: string, userVars: FullStoryUserVars): void {
  window.FS?.identify(uid, userVars);
}

export function trackFSEvent(eventName: string, properties?: Record<string, unknown>): void {
  window.FS?.event(eventName, properties ?? {});
}